import { render, staticRenderFns } from "./audioCompose.vue?vue&type=template&id=0d0c3357&scoped=true&"
import script from "./audioCompose.vue?vue&type=script&lang=js&"
export * from "./audioCompose.vue?vue&type=script&lang=js&"
import style0 from "./audioCompose.vue?vue&type=style&index=0&id=0d0c3357&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0c3357",
  null
  
)

component.options.__file = "audioCompose.vue"
export default component.exports